import { useState } from "react";
import {
  Dialog,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { Close, Save } from "@mui/icons-material";
import theme from "../../theme/theme";

export const CreateCustomerDialog = ({
  open,
  onClose,
  saving,
  onSave,
  errors = {},
}) => {
  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    is_active: true,
  });

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setCustomer({
      ...customer,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const submit = () => {
    onSave(customer);
    if (!saving) {
      // Only reset when save succeeded (dialog closed logic via parent typically)
      setCustomer({
        name: "",
        email: "",
        phone: "",
        address: "",
        is_active: true,
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={!saving ? onClose : undefined}
      PaperProps={{
        sx: {
          borderRadius: theme.dialog.borderRadius,
          minWidth: theme.dialog.minWidth,
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            fontWeight={"bold"}
            color={theme.palette.primary.main}
          >
            New Customer
          </Typography>
        </Box>
        <Box>
          <IconButton onClick={onClose} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ p: 4 }}>
        <TextField
          fullWidth
          label="Full Name"
          name="name"
          value={customer.name}
          onChange={handleChange}
          disabled={saving}
          error={!!errors.name}
          helperText={errors.name?.[0] || errors.name}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={customer.email}
          onChange={handleChange}
          disabled={saving}
          error={!!errors.email}
          helperText={errors.email?.[0] || errors.email}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Phone"
          name="phone"
          value={customer.phone}
          onChange={handleChange}
          disabled={saving}
          error={!!errors.phone}
          helperText={errors.phone?.[0] || errors.phone}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Address"
          name="address"
          multiline
          rows={3}
          value={customer.address}
          onChange={handleChange}
          disabled={saving}
          error={!!errors.address}
          helperText={errors.address?.[0] || errors.address}
          sx={{ mb: 2 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={customer.is_active}
              onChange={handleChange}
              name="is_active"
              color="primary"
              disabled={saving}
            />
          }
          label={customer.is_active ? "Active" : "Inactive"}
        />
      </Box>

      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          disabled={saving}
          sx={{
            backgroundColor: theme.button.backgroundColor,
            color: "#000",
            borderRadius: theme.button.borderRadius,
          }}
        >
          Close
        </Button>
        <Button
          variant="contained"
          onClick={submit}
          disabled={saving}
          sx={{
            backgroundColor: theme.button.editBackgroundColor,
            borderRadius: theme.button.borderRadius,
          }}
          startIcon={<Save />}
        >
          {saving ? "Saving..." : "Save Customer"}
        </Button>
      </Box>
    </Dialog>
  );
};
